<template>
    <el-dialog :title="title" :visible.sync="visible" width="30%" @close="close">
        <el-form :model="form" :rules="rules" ref="ruleForm" :inline="true" label-width="80px">
            <el-form-item label="上级分类" v-if="type == '2'">
                <el-input :value="form.parentClassifyName" auto-complete="off" disabled></el-input>
            </el-form-item>
            <el-form-item label="分类名称" prop="name">
                <el-input v-model="form.name" maxlength="20" auto-complete="off"></el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="ok">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import {
    addBaseItemDisplayClassify,
} from '@servers/base/display/index.js';
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        type: {
            type: [Number, String],
            default: '1',
        },
        rowData:{
            type: Object,
            default: {},
        },
    },
    data () {
        return {
            dialogVisible: false,
            form: {
                name: "",
                parentClassifyName: "", 
            },
            rules: {
                name: [
                    { required: true, message: '分类名称不能为空！' }
                ],
            }
        }
    },
    watch: {
        rowData: {
            handler(v) {
                this.form.parentClassifyName = v.name;
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        title() {
            return this.type == '1' ? '新增分类': '添加下级';
        },
    },
    methods: {
        ok () {
            this.$refs.ruleForm.validate(async(valid) => {
                if (valid) {
                    let params = {};
                    if (this.type == '1') {
                        params = {
                            name: this.form.name,
                            parentId: 0,
                            level: 1,
                        }
                    } else {
                        params = {
                            name: this.form.name,
                            parentId: this.rowData.id,
                            level: 2,
                        }
                    }
                    const res = await addBaseItemDisplayClassify(params);
                    if (res) {
                        this.clearData()
                        this.$emit("ok");
                    }
                    
                } else {
                    return false;
                }
            });
           
        },
        close () {
            this.clearData();
            this.$emit("close");
        },
        clearData () {
            this.$refs.ruleForm.resetFields();
            this.dialogFormVisible = false;
        }
    },

}
</script>

<style lang="scss" scoped></style>
